import React from "react";
import numtoString from "src/lib/numToString";
import { Datepicker } from "@mobiscroll/react5";
import "react-circular-progressbar/dist/styles.css";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import { useStore } from "src/store/Store";
const boxInputProps = {
  inputStyle: "box",
  labelStyle: "stacked",
  placeholder: "Since Please Select",
  className: "add-font-since",
};

const CardExpanded = (props) => {
  const { globalStateKPI } = useStore();

  const [value, setValue] = React.useState("-");
  const [growth, setGrowth] = React.useState(null);
  const [growthPercent, setGrowthPercent] = React.useState("-");

  React.useEffect(() => {
    const fetchData = async () => {
      if (props?.item?.api) {
        const val = sessionStorage.getItem(props.item.title);
        if (val && val > 0) {
          setValue(val);
        } else {
          const res = await props?.item?.api();
          sessionStorage.setItem(props.item.title, +res);
          if (props.item.showRupees) {
            setValue(+res);
          } else {
            setValue(res);
          }
        }
      } else {
        if (props?.item?.globalState) {
          setValue(globalStateKPI[props.item.globalState]);
        } else {
          const val = sessionStorage.getItem(props.item.title);
          if (val) {
            setValue(val);
          }
        }
      }
    }

    fetchData();
  }, []);

  React.useEffect(() => {
    if (props?.item?.globalState) {
      setValue(globalStateKPI[props.item.globalState]);
    }
  }, [globalStateKPI]);

  React.useEffect(() => {
    const fetchGrowth = async () => {
      if (props?.item?.growthApi && growth) {
        const res = await props?.item?.growthApi(growth);
        setGrowthPercent(res);
      }
    }
    fetchGrowth();
  }, [growth]);

  return (
    <>
      <div className="card widgets card-effect mr-3 mb-3">
        <div
          className="card-body"
          style={{ overflowY: "visible", height: "135px" }}
        >
          <h5 className="card-title text-white add-radius text-center">
            {props.item.title}
          </h5>

          <div className="card-text add-display-direction pb-2">
            <div className="leftSide">
              <CircularProgressbarWithChildren
                className={props.item?.Circular}
                value={props.item?.percentage}
              >
                <img
                  style={{ width: 30 }}
                  src={props.item?.icon}
                  alt="Billing"
                />
                <div style={{ fontSize: 12, marginTop: -5 }}></div>
              </CircularProgressbarWithChildren>
            </div>
            <div className="RightSide add-height-line">
              <div className="FourthCardNumber mb-0">
                {props.item.showRupees && (
                  <span className="rsIcon" style={{ fontSize: "25px" }}>&#8377;</span>
                )}
                <b style={{ fontSize: "25px" }}>
                  {value == "-" ? value : numtoString(value)}
                </b>
                <br />

                {props.item.footer ? (
                  <p
                    style={{
                      fontSize: "35%",
                      color: "grey",
                    }}
                    className="float-right"
                  >
                    {props.item.footer}
                  </p>
                ) : (
                  <div
                    style={{
                      fontSize: "35%",
                      color: "green",
                    }}
                    className="float-right"
                  >
                    {growthPercent} %{" "}
                    <b style={{ fontWeight: "normal", color: "grey" }}>
                      Growth
                    </b>
                    <span
                      style={{
                        alignItems: "center",
                        color: "grey",
                        fontWeight: "normal",
                        display: "flex",
                      }}
                    >
                      <Datepicker
                        controls={["calendar"]}
                        inputProps={boxInputProps}
                        displayTimezone="local"
                        dateFormat="DDD D MMM, YYYY"
                        onChange={(e) =>
                          setGrowth(new Date(e.value).toISOString())
                        }
                        value={growth}
                        style={{ margin: "0%", width: "10%!important" }}
                      />
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardExpanded;
